import React from 'react';
import Carousel from 'react-material-ui-carousel';
import { Paper, Button, Typography, Box } from '@mui/material';
import { NavLink } from 'react-router-dom';

// Import your images
import imageSlide1 from '../../assets/img/png/10000.png';
import imageSlide2 from '../../assets/img/png/10001.png';
import imageSlide3 from '../../assets/img/jpg/10000.jpg';

// The interface for a single slide's data
export interface ISlide {
  image: string;
  title: string;
  description: string;
  buttonText: string;
  buttonLink: string;
  textAlign: 'left' | 'center' | 'right';
}

// The interface for the component's props
interface CarouselItemProps {
  item: ISlide;
}

// 1. DATA is separated from the component logic for maintainability
// CORRECTED: This should be an array of ISlide objects, not CarouselItemProps
const slideData: ISlide[] = [
  {
    image: imageSlide1,
    title: 'Conforto e Eficiência em Cada Ambiente',
    description: 'Na Clima Tropical, garantimos que o ar da sua casa esteja sempre fresco e agradável, com soluções de climatização personalizadas.',
    buttonText: 'Saiba mais',
    buttonLink: '/servicos/residenciais',
    textAlign: 'left',
  },
  {
    image: imageSlide2,
    title: 'Climatização Automotiva de Qualidade',
    description: 'Mantenha o ar do seu carro sempre puro e climatizado. Oferecemos manutenção de sistemas de ar condicionado para veículos de todos os tipos.',
    buttonText: 'Saiba mais',
    buttonLink: '/servicos/automotivos',
    textAlign: 'center',
  },
  {
    image: imageSlide3,
    title: 'Soluções Completas para Sua Climatização',
    description: 'Desde a instalação até a manutenção, a Clima Tropical está aqui para garantir seu conforto em qualquer situação.',
    buttonText: 'Saiba mais',
    buttonLink: '/sobre',
    textAlign: 'right',
  },
];

// 2. A dedicated component for rendering a single slide (Component Composition)
const CarouselItem: React.FC<CarouselItemProps> = ({ item }) => {
  //const theme = useTheme();

  // Map text alignment to flexbox alignment
  const alignItems = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end',
  };

  return (
    <Paper
      elevation={6}
      sx={{
        position: 'relative',
        height: '75vh',
        minHeight: '400px',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: `url(${item.image})`,
        color: '#fff',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1,
        },
      }}
    >
      <Box
        sx={{
          position: 'relative',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: alignItems[item.textAlign], // Use the mapped alignment
          textAlign: item.textAlign,
          px: { xs: 4, md: 10 },
          zIndex: 2,
        }}
      >
        <Typography 
          variant="h2" 
          component="h1" 
          gutterBottom
          sx={{ 
            fontWeight: 'bold', 
            maxWidth: '800px', 
            fontSize: { xs: '2.5rem', md: '3.5rem' }
          }}
        >
          {item.title}
        </Typography>
        <Typography 
          variant="h6" 
          component="p" 
          sx={{ 
            mb: 3, 
            opacity: 0.85, 
            maxWidth: '800px',
            fontSize: { xs: '1rem', md: '1.25rem' }
          }}
        >
          {item.description}
        </Typography>
        <Button
          component={NavLink}
          to={item.buttonLink}
          variant="contained"
          color="primary"
          size="large"
          sx={{ mt: 2, fontWeight: 'bold' }}
        >
          {item.buttonText}
        </Button>
      </Box>
    </Paper>
  );
}

// 3. The main Carousel component that uses the library
export default function HeroCarousel() {
  return (
    <Carousel
      animation="slide"
      duration={700}
      interval={8000}
      navButtonsAlwaysVisible={true}
      indicators={true}
      stopAutoPlayOnHover={true}
      indicatorIconButtonProps={{
          style: {
              padding: '10px',
              color: 'rgba(255, 255, 255, 0.5)'
          }
      }}
      activeIndicatorIconButtonProps={{
          style: {
              color: 'white'
          }
      }}
      navButtonsProps={{
          style: {
              backgroundColor: 'rgba(0, 0, 0, 0.3)',
              borderRadius: '50%'
          }
      }}
    >
      {slideData.map((item, i) => (
        <CarouselItem key={i} item={item} />
      ))}
    </Carousel>
  );
}